export default __webpack_public_path__ + "static/media/body-3.0ae6ee15.png";